import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  RulerPopup: {
    position: 'absolute',
    backgroundColor: theme.palette.primary.main,
    opacity: '0.6',
    boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
    borderRadius: 10,
    border: `1px solid ${theme.palette.popupBorderColor}`,
    bottom: 12,
    left: -50,
    fontSize: 15,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    '&__text': {
      '&--color': {
        color: theme.palette.fontColor,
      },
    },
  },
  RulerPopupCalc: {
    minWidth: props => (props.unit ? 'fit-content' : 150),
    padding: props => (props.unit ? 8 : 15),
  },
}));

export { useStyles };
